import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Syskd } from '../entity/Syskd-angular';

export interface SyskdData {     COMPANY: string ;     CREATOR: string;     USR_GROUP: string ;     CREATE_DATE: string;     MODIFIER: string;     MODI_DATE: string;     FLAG: number;     KD001: Date;            // 訊息時間 0     KD002: string;            // 序號 4     KD003: string;            // 程式代號 20     KD004: string;            // DBName 20     KD005: string;            // USERID 10     KD006: string;            // 是否定時作業 1 [DEF:"N"]    KD007: string;            // 內容 300     KD008: string;            // 工作電腦 15 }


@Injectable({
  providedIn: 'root'
})
export class SyskdServicePkg extends JkEntityV2 { 


  constructor() {
    super();
    this.linkMasterFields = '' ; 
    this.defaultItem = new Syskd(); 
    this.entityType.type = EntityType.master;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數', 
        KD001 : '訊息時間' , KD002 : '序號' , KD003 : '程式代號' , KD004 : 'DBName' , KD005 : 'USERID' , KD006 : '是否定時作業' , KD007 : '內容' , KD008 : '工作電腦'  }; 

    this.fieldNames = 'KD001,KD002,KD003,KD004,KD005,KD006,KD007,KD008' ;
    this.fieldLengths = {KD001 : 0 ,KD002 : 4 ,KD003 : 20 ,KD004 : 20 ,KD005 : 10 ,KD006 : 1 ,KD007 : 300 ,KD008 : 15 } ;
    this.columnDefs = [
      { field: "KD001", headerName: "訊息時間",headerTooltip: "",width:80,cellDataType: "date", valueFormatter: (p:any) => { return jkLib.datetimeFormatter(p.value)},  },
      { field: "KD002", headerName: "序號",headerTooltip: "",width:102,cellDataType: "text", },
      { field: "KD003", headerName: "程式代號",headerTooltip: "",width:230,cellDataType: "text", },
      { field: "KD004", headerName: "DBName",headerTooltip: "",width:230,cellDataType: "text", },
      { field: "KD005", headerName: "USERID",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "KD006", headerName: "是否定時作業",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
      { field: "KD007", headerName: "內容",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "KD008", headerName: "工作電腦",headerTooltip: "",width:190,cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'SYSKD' ;
    this.isSys =true; 
    this.sqlSelect = `SELECT SYSKD.*  FROM SYSKD` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = ` ORDER BY KD001,KD002,KD003,KD004` ;
    this.keyFields = ['KD001','KD002','KD003','KD004'];
    this.url = '/db/crud'; 
    this.rememberFields = [];
    this.requiredFields = ['KD001','KD002','KD003','KD004'];
    this.seqField = 'KD002' ;
    this.seqFieldLength = 4 ;
  }
  override async validateItem(item: Syskd): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem:Syskd): Promise<Syskd> {
  await  super.newRecord(newItem);
    return newItem;
  }




}

